export function IconArg() {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="7" fill="#74ACDF" />
            <mask
                id="mask0_2730_73437"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="14"
                height="14"
            >
                <circle cx="7" cy="7" r="7" fill="#74ACDF" />
            </mask>
            <g mask="url(#mask0_2730_73437)">
                <rect x="-0.65625" y="4.59375" width="15.3125" height="4.8125" fill="white" />
            </g>
            <path
                d="M6.89014 5.33203L7.30837 6.53521L8.5819 6.56116L7.56685 7.33072L7.93571 8.54994L6.89014 7.82237L5.84458 8.54994L6.21344 7.33072L5.19839 6.56116L6.47192 6.53521L6.89014 5.33203Z"
                fill="#F6B40E"
            />
            <path
                d="M5.34839 6.21731L6.59949 6.45671L7.25873 5.36678L7.41766 6.63062L8.65796 6.92078L7.50509 7.46248L7.6124 8.73175L6.74096 7.8027L5.56697 8.29698L6.18126 7.1811L5.34839 6.21731Z"
                fill="#F6B40E"
            />
            <path
                d="M5.63281 5.85156L6.77932 6.40661L7.69819 5.52444L7.5246 6.78635L8.64754 7.38764L7.39375 7.6125L7.16889 8.86629L6.5676 7.74335L5.30569 7.91694L6.18786 6.99807L5.63281 5.85156Z"
                fill="#F6B40E"
            />
            <path
                d="M5.99948 5.57153L6.96327 6.4044L8.07915 5.79011L7.58487 6.96409L8.51392 7.83554L7.24465 7.72823L6.70295 8.8811L6.41279 7.6408L5.14895 7.48187L6.23888 6.82263L5.99948 5.57153Z"
                fill="#F6B40E"
            />
            <path
                d="M6.43012 5.39117L7.1455 6.44511L8.38235 6.14056L7.60106 7.14661L8.27291 8.22882L7.07467 7.79666L6.25304 8.77004L6.29377 7.4969L5.11413 7.01628L6.33755 6.6616L6.43012 5.39117Z"
                fill="#F6B40E"
            />
        </svg>
    );
}

export function IconGlobal() {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7 14C3.1386 14 0 10.8614 0 7C0 3.1386 3.1386 0 7 0C10.8614 0 14 3.1386 14 7C14 10.8614 10.8614 14 7 14ZM7 0.976744C3.67907 0.976744 0.976744 3.67907 0.976744 7C0.976744 10.3209 3.67907 13.0233 7 13.0233C10.3209 13.0233 13.0233 10.3209 13.0233 7C13.0233 3.67907 10.3209 0.976744 7 0.976744Z"
                fill="#111111"
                fillOpacity="0.7"
            />
            <path
                d="M4.80437 13.4154H4.2108C3.96743 13.4154 3.76562 13.1916 3.76562 12.9218C3.76562 12.6519 3.95556 12.4348 4.19893 12.4282C3.26702 8.90066 3.26702 5.09673 4.19893 1.56921C3.95556 1.56263 3.76562 1.34545 3.76562 1.07562C3.76562 0.805792 3.96743 0.582031 4.2108 0.582031H4.80437C4.94682 0.582031 5.08334 0.661006 5.16644 0.786048C5.24954 0.917672 5.27328 1.0822 5.2258 1.23357C4.10989 4.95195 4.10989 9.04545 5.2258 12.7704C5.27328 12.9218 5.24954 13.0863 5.16644 13.2179C5.08334 13.3364 4.94682 13.4154 4.80437 13.4154Z"
                fill="#111111"
            />
            <path
                d="M9.19558 13.4154C9.1482 13.4154 9.10082 13.4088 9.05344 13.3891C8.82246 13.3035 8.69217 13.0207 8.77508 12.7641C9.88851 9.04735 9.88851 4.95563 8.77508 1.23229C8.69809 0.975732 8.82246 0.692863 9.05344 0.607345C9.29034 0.521827 9.53908 0.659972 9.61607 0.916527C10.7946 4.83722 10.7946 9.1526 9.61607 13.0667C9.55685 13.2838 9.37917 13.4154 9.19558 13.4154Z"
                fill="#111111"
            />
            <path
                d="M6.99639 10.5C5.16117 10.5 3.33254 10.2687 1.56968 9.80018C1.5631 10.0374 1.34604 10.2331 1.07634 10.2331C0.806654 10.2331 0.583008 10.0315 0.583008 9.78832V9.19526C0.583008 9.05292 0.661942 8.91652 0.78692 8.83349C0.918477 8.75046 1.08292 8.72674 1.23421 8.77418C4.95068 9.88914 9.04867 9.88914 12.7651 8.77418C12.9164 8.72674 13.0809 8.75046 13.2124 8.83349C13.344 8.91652 13.4163 9.05292 13.4163 9.19526V9.78832C13.4163 10.0315 13.1927 10.2331 12.923 10.2331C12.6533 10.2331 12.4362 10.0433 12.4297 9.80018C10.6602 10.2687 8.8316 10.5 6.99639 10.5Z"
                fill="#111111"
            />
            <path
                d="M12.9277 5.25C12.875 5.25 12.8224 5.24407 12.7697 5.22629C9.05058 4.11198 4.94966 4.11198 1.23053 5.22629C0.967224 5.30334 0.690757 5.17887 0.605184 4.94771C0.526194 4.71063 0.664427 4.46169 0.921146 4.38463C4.84434 3.20512 9.16248 3.20512 13.0791 4.38463C13.3358 4.46169 13.4806 4.71655 13.3885 4.94771C13.3292 5.13146 13.1317 5.25 12.9277 5.25Z"
                fill="#111111"
            />
        </svg>
    );
}

export const CircleArrowUp = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="16" fill="#269532" />
            <path
                d="M20.0467 14.8809C19.9201 14.8809 19.7934 14.8343 19.6934 14.7343L16.0001 11.0409L12.3067 14.7343C12.1134 14.9276 11.7934 14.9276 11.6001 14.7343C11.4067 14.5409 11.4067 14.2209 11.6001 14.0276L15.6467 9.98094C15.8401 9.7876 16.1601 9.7876 16.3534 9.98094L20.4001 14.0276C20.5934 14.2209 20.5934 14.5409 20.4001 14.7343C20.3067 14.8343 20.1734 14.8809 20.0467 14.8809Z"
                fill="white"
            />
            <path
                d="M16 22.1653C15.7267 22.1653 15.5 21.9386 15.5 21.6653V10.4453C15.5 10.172 15.7267 9.94531 16 9.94531C16.2733 9.94531 16.5 10.172 16.5 10.4453V21.6653C16.5 21.9386 16.2733 22.1653 16 22.1653Z"
                fill="white"
            />
        </svg>
    );
};
export const CircleArrowDown = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="16" fill="#CF2B2B" />
            <path
                d="M16.0001 22.1661C15.8734 22.1661 15.7467 22.1194 15.6467 22.0194L11.6001 17.9728C11.4067 17.7794 11.4067 17.4594 11.6001 17.2661C11.7934 17.0728 12.1134 17.0728 12.3067 17.2661L16.0001 20.9594L19.6934 17.2661C19.8867 17.0728 20.2067 17.0728 20.4001 17.2661C20.5934 17.4594 20.5934 17.7794 20.4001 17.9728L16.3534 22.0194C16.2534 22.1194 16.1267 22.1661 16.0001 22.1661Z"
                fill="white"
            />
            <path
                d="M16 22.052C15.7267 22.052 15.5 21.8254 15.5 21.552V10.332C15.5 10.0587 15.7267 9.83203 16 9.83203C16.2733 9.83203 16.5 10.0587 16.5 10.332V21.552C16.5 21.8254 16.2733 22.052 16 22.052Z"
                fill="white"
            />
        </svg>
    );
};
export const CircleEqual = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="16" fill="#1673FE" fillOpacity="0.5" />
            <path
                d="M12.321 14.9398C12.0941 14.9398 11.9102 14.7559 11.9102 14.529V13.3366C11.9102 13.1097 12.0941 12.9258 12.321 12.9258H19.4993C19.7262 12.9258 19.9102 13.1097 19.9102 13.3366V14.529C19.9102 14.7559 19.7262 14.9398 19.4993 14.9398H12.321ZM12.321 18.7834C12.0941 18.7834 11.9102 18.5994 11.9102 18.3725V17.1721C11.9102 16.9452 12.0941 16.7613 12.321 16.7613H19.4993C19.7262 16.7613 19.9102 16.9452 19.9102 17.1721V18.3725C19.9102 18.5994 19.7262 18.7834 19.4993 18.7834H12.321Z"
                fill="white"
            />
        </svg>
    );
};
export const IconMessageQuestion = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.33325 14.8783C5.14659 14.8783 4.95324 14.8317 4.77991 14.7383C4.39991 14.5383 4.16659 14.1383 4.16659 13.7116V12.765C2.15325 12.5583 0.833252 11.0783 0.833252 8.95829V4.95833C0.833252 2.665 2.37325 1.125 4.66659 1.125H11.3333C13.6266 1.125 15.1666 2.665 15.1666 4.95833V8.95829C15.1666 11.2516 13.6266 12.7916 11.3333 12.7916H8.81991L5.9799 14.685C5.78657 14.8117 5.55992 14.8783 5.33325 14.8783ZM4.66659 2.11833C2.94659 2.11833 1.83325 3.23166 1.83325 4.95166V8.9517C1.83325 10.6717 2.94659 11.785 4.66659 11.785C4.93992 11.785 5.16659 12.0117 5.16659 12.285V13.705C5.16659 13.7917 5.21992 13.8317 5.25326 13.8517C5.28659 13.8717 5.35326 13.8917 5.4266 13.845L8.39327 11.8717C8.47327 11.8184 8.57326 11.785 8.67326 11.785H11.3399C13.0599 11.785 14.1733 10.6717 14.1733 8.9517V4.95166C14.1733 3.23166 13.0599 2.11833 11.3399 2.11833H4.66659Z"
                fill="white"
                fillOpacity="0.4"
            />
            <path
                d="M7.99996 8.07422C7.72663 8.07422 7.49996 7.84755 7.49996 7.57422V7.43424C7.49996 6.66091 8.06661 6.2809 8.27995 6.13424C8.52661 5.96757 8.60661 5.85424 8.60661 5.68091C8.60661 5.34757 8.33329 5.07422 7.99996 5.07422C7.66663 5.07422 7.39331 5.34757 7.39331 5.68091C7.39331 5.95424 7.16664 6.18091 6.89331 6.18091C6.61998 6.18091 6.39331 5.95424 6.39331 5.68091C6.39331 4.79424 7.11329 4.07422 7.99996 4.07422C8.88663 4.07422 9.60661 4.79424 9.60661 5.68091C9.60661 6.44091 9.04663 6.8209 8.83997 6.9609C8.57997 7.13423 8.49996 7.24758 8.49996 7.43424V7.57422C8.49996 7.85422 8.27329 8.07422 7.99996 8.07422Z"
                fill="white"
                fillOpacity="0.4"
            />
            <path
                d="M8 9.73438C7.72 9.73438 7.5 9.50771 7.5 9.23438C7.5 8.96104 7.72667 8.73438 8 8.73438C8.27333 8.73438 8.5 8.96104 8.5 9.23438C8.5 9.50771 8.28 9.73438 8 9.73438Z"
                fill="white"
                fillOpacity="0.4"
            />
        </svg>
    );
};

export const greenArrow = (
    <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.74297 5.91958L5.25312 0.71333C5.12461 0.564307 4.87715 0.564307 4.74727 0.71333L0.257423 5.91958C0.0906257 6.11372 0.241016 6.3981 0.510352 6.3981H9.49004C9.75937 6.3981 9.90977 6.11372 9.74297 5.91958Z"
            fill={"#269532"}
        />
    </svg>
);

export const redArrow = (
    <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.1565 0.601562H1.17686C0.90752 0.601562 0.75713 0.885938 0.923926 1.08008L5.41377 6.28633C5.54228 6.43535 5.78975 6.43535 5.91963 6.28633L10.4095 1.08008C10.5763 0.885938 10.4259 0.601562 10.1565 0.601562Z"
            fill="#FF4D4F"
        />
    </svg>
);

export const equalSign = (
    <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.781109 2.57088C0.582575 2.57088 0.421631 2.40994 0.421631 2.2114L0.421631 1.16807C0.421631 0.969538 0.582575 0.808594 0.781109 0.808594L7.06215 0.808594C7.26069 0.808594 7.42163 0.969538 7.42163 1.16807V2.2114C7.42163 2.40994 7.26069 2.57088 7.06215 2.57088L0.781109 2.57088ZM0.781109 5.93397C0.582575 5.93397 0.421631 5.77303 0.421631 5.57449L0.421631 4.52414C0.421631 4.32561 0.582575 4.16466 0.781109 4.16466L7.06215 4.16466C7.26069 4.16466 7.42163 4.32561 7.42163 4.52414V5.57449C7.42163 5.77303 7.26069 5.93397 7.06215 5.93397L0.781109 5.93397Z"
            fill="#1673FE"
        />
    </svg>
);
